export enum ResponseMsg {
  Success = "Success",
  Required = "Required",
  ErrorMsg = "Application Error",
  Warning = "Warning",
  AddProject = "Project created successfully.",
  CategoryToolTip = "Select appropriate Category.  If you believe you require an additional category for your product please submit an IT ticket",
  SubCategoryToolTip = "Select appropriate Sub-category.   If you believe you require an additional Sub-category for your product please submit an IT ticket.",
  ShortDescToolTip = "Enter a short description, no longer that 20 characters.  This should include Year or Version.",
  DescriptionToolTip = "Describe the purpose of this project.  This information will display when users select the timesheet project.",
  ProductToolTip = "Select appropriate product.",
  ApproverIDToolTip = "This field is utilize for the timesheet projects you want to go through manual approval.  If you want the line manager to approve timesheets do not fill in this field.",
  AddProjectTitle = "Add Project",
  EditProjectTitle = "Edit Project",
  UpdateProject = "Project details updated successfully.",
  ProjectNameExists = "Project Name already exists.Please select a different Category/Sub-Category/Short Description.",
  ProjectNameExistsIT = "Project Name already exists.Please select a different Department/Program/Short Description.",
  ProjectDoesNotExists = "Project does not exists.",
  ErrAddProject = "Error occurred while creating a new project",
  ApproveProject = "Project approved successfully",
  ErrApproveProject = "Error occurred while approving project",
  ErrApproveNotValid = "There is nothing here to Approve/Reject by you for this request",
  RejectProject = "Project rejected successfully",
  ErrRejectProject = "Error occurred while rejecting project",
  ErrProjectDetails = "Error occurred while loading project details",
  StartDateFormat = "Start Date is not a valid format",
  EndDateFormat = "End Date is not a valid format",
  StartDateValid = "Start Date must be less than End Date",
  StartDateRequired = "Please enter both: Start Date and End Date",
  SubCategoryInfo = "Please create an IT-Helpdesk ticket,if Sub Category list is empty.",
  ManagerMembership = "Select manager that all employees to have access to this project in XM.",
  UserMembership = "Select users who will have access to this project in XM.",
  EnterValidCharacters = "Only standard characters (Aa-Zz), numbers (0-9) and underscore character (_) are allowed.",
  ValidApprover = "There is nothing here to approve or reject by you for this request.",
  UploadTypeToolTip="Select appropriate upload type from the list.",
  ErrUploadFile = "Error occurred while uploading the file.",
  EditDetaileQuota="Edit detailed quota for "
}